import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import Button from '~/components/Buttons/Button'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'
import { useGetUserLocationInfoFromIpQuery } from '~/redux/apis/geo-location-api'
import { useAppSelector } from '~/redux/hooks'
import { selectIsSubscriptionApplicable } from '~/redux/slices/subscription.slice'
import ROUTES from '~/shared/constants/routes.const'
import useGetStartedEntryRoute from '~/get-started/hooks/useGetStartedEntryRoute'
import { AppLanguage } from '~/types/locale'
import appConfig from '~/config/app'

export const MenuRightPreview = (): React.ReactElement => {
  const { t } = useTranslation('menu')
  const router = useRouter()
  const isSubscriptionApplicable = useAppSelector(selectIsSubscriptionApplicable)
  const entryRoute = useGetStartedEntryRoute()
  const isUkrainian = router.locale === AppLanguage.UA
  const { data } = useGetUserLocationInfoFromIpQuery()
  const isNorwegian = data?.countryCode === CurriculumCountryCodes.NORWAY.toUpperCase()
  const isMobileApp = appConfig.isMobileApp

  return (
    <div className="flex items-center gap-3 pr-2">
      <Button
        className="bg-purple/90 px-1.5 rounded h-7 md:h-10 text-white text-xxs md:!text-btn-md text-center hover:scale-110 duration-300"
        href={ROUTES.LOGIN}
        noPadding
        size="x-small"
      >
        {t('login')}
      </Button>
      {!isMobileApp && ( // hide CTA in menu for mobile app as the entry point is different
        <Button
          className="bg-orange px-1.5 rounded h-7 md:h-10 text-xxs md:!text-btn-md text-center hover:scale-110 duration-300"
          href={entryRoute}
          noPadding
          size="x-small"
        >
          {isSubscriptionApplicable && !isUkrainian
            ? isNorwegian
              ? t('getStarted')
              : t('signUpForFree')
            : t('register')}
        </Button>
      )}
    </div>
  )
}
